import { render } from "./CollectionAccount.vue?vue&type=template&id=23cad984&ts=true"
import script from "./CollectionAccount.vue?vue&type=script&lang=ts"
export * from "./CollectionAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__